var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OptionalFeed',_vm._b({},'OptionalFeed',{
    title: this.$t('commented_post'),
    query: { myCommentList: 1 },
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }